/*
 * @Author: Garywoner
 * @Date: 2021-04-25 22:43:43
 * @Last Modified by: Garywoner
 * @Last Modified time: 2021-04-25 22:43:43
 */

import React, { Component } from "react";
import cookie from "react-cookies";

import { withRouter } from "react-router";

// reactstrap components
import { Button as BootButton, Row, Col, UncontrolledAlert } from "reactstrap";

// element-react components
//import { Form, Input, Switch, Dialog, Button } from "element-react";
import { Form, Input, Switch, Button, Dialog, Radio, Collapse } from "element-react";
// custom components
import Upload from "components/Upload";
import Select_pure from "components/Select_pure";
import Search_lib from "components/Search_lib";
import Search_lib_private from "components/Search_lib_private";

// custom js
import dateFormater from "utils/dateFormater";

// requests
import createBatch from "api/createBatch";
import craeteJointJob from "api/craeteJointJob";
import getBatchIdByLibTag from "api/getBatchIdByLibTag";
import ssoRefresh from "../../api/ssoRefresh";

class CreateJobForm extends Component {
  state = {
    needCheck: false,
    needManualScreen: true,
    batchTitle: "",
    jobTitle: "",
    selectCodeOption: [
    ],
    file: [],
    file_format: "",
    suffix_screen: "",
    submited: false,
    showWarrning: false,
    // 高级选项是否展开
    activeCollapse: [],
    lib_tag: "",
    lib_tag_p: "",
    showTips: false,
    private_lib: true,
    with_self: true,
    CheckType:1,
  };
  langList = {'C': ['c', 'ec', 'pgc'], 'C Shell': ['csh', 'tcsh'], 'C#': ['cs'], 'C++': ['C', 'c++', 'cc', 'cpp', 'CPP', 'cxx', 'inl', 'pcc'], 'C/C++ Header': ['h', 'H', 'hh', 'hpp', 'hxx'],'Java': ['java'], 'JavaScript': ['es6', 'js'], 'Python': ['py', 'pyw'], 'Verilog-SystemVerilog': ['sv', 'svh', 'v'], 'Rust': ['rs'], 'SAS': ['sas'], 'Sass': ['sass', 'scss'], 'Scala': ['scala'],  'R': ['r', 'R'], 'Text': ['txt'], 'ABAP': ['abap'], 'ActionScript': ['as'], 'Ada': ['ada', 'adb', 'ads', 'pad'], 'ADSO/IDSM': ['adso'], 'Agda': ['agda', 'lagda'], 'AMPLE': ['ample', 'dofile', 'startup'], 'Ant': ['build.xml', 'build.xml'], 'ANTLR Grammar': ['g', 'g4'], 'Apex Class': ['cls'], 'Apex Trigger': ['trigger'], 'Arduino Sketch': ['ino', 'pde'], 'AsciiDoc': ['adoc', 'asciidoc'], 'ASP': ['asa', 'asp'], 'ASP.NET': ['asax', 'ascx', 'asmx', 'aspx', 'master', 'sitemap', 'webinfo'], 'AspectJ': ['aj'], 'Assembly': ['asm', 'S', 's'], 'AutoHotkey': ['ahk'], 'awk': ['awk'], 'Blade': ['blade.php'], 'Bourne Again Shell': ['bash'], 'Bourne Shell': ['sh'], 'BrightScript': ['brs'], 'builder': ['xml.builder'], 'CCS': ['ccs'], 'Chapel': ['chpl'], 'Clean': ['dcl', 'icl'], 'Clojure': ['clj'], 'ClojureC': ['cljc'], 'ClojureScript': ['cljs'], 'CMake': ['cmake', 'CMakeLists.txt'], 'COBOL': ['cbl', 'CBL', 'cob', 'COB'], 'CoffeeScript': ['coffee'], 'ColdFusion': ['cfm'], 'ColdFusion CFScript': ['cfc'], 'Coq': ['v'], 'Crystal': ['cr'], 'CSON': ['cson'], 'CSS': ['css'], 'Cucumber': ['feature'], 'CUDA': ['cu', 'cuh'], 'Cython': ['pyx'], 'D': ['d'], 'DAL': ['da'], 'Dart': ['dart'], 'DIET': ['dt'], 'diff': ['diff'], 'DITA': ['dita'], 'DOORS Extension Language': ['dxl'], 'DOS Batch': ['bat', 'BAT', 'BTM', 'btm', 'CMD', 'cmd'], 'Drools': ['drl'], 'DTD': ['dtd'], 'dtrace': ['d'], 'ECPP': ['ecpp'], 'EEx': ['eex'], 'EJS': ['ejs'], 'Elixir': ['ex', 'exs'], 'Elm': ['elm'], 'Embedded Crystal': ['ecr'], 'ERB': ['ERB', 'erb'], 'Erlang': ['erl', 'hrl'], 'Expect': ['exp'], 'F#': ['fsi', 'fs', 'fs'], 'F# Script': ['fsx'], 'Fennel': ['fnl'], 'Fish Shell': ['fish'], 'Focus': ['focexec'], 'Forth': ['4th', 'e4', 'f83', 'fb', 'forth', 'fpm', 'fr', 'frt', 'ft', 'fth', 'rx', 'fs', 'f', 'for'], 'Fortran 77': ['F', 'f77', 'F77', 'FOR', 'FTN', 'ftn', 'pfo', 'f', 'for'], 'Fortran 90': ['F90', 'f90'], 'Fortran 95': ['f95', 'F95'], 'Freemarker Template': ['ftl'], 'FXML': ['fxml'], 'GDScript': ['gd'], 'Gencat NLS': ['msg'], 'Glade': ['glade', 'ui'], 'GLSL': ['comp', 'frag', 'geom', 'glsl', 'tesc', 'tese', 'vert'], 'Go': ['go'], 'Gradle': ['gradle', 'gradle.kts'], 'Grails': ['gsp'], 'GraphQL': ['gql', 'graphql'], 'Groovy': ['gant', 'groovy'], 'Haml': ['haml'], 'Handlebars': ['handlebars', 'hbs'], 'Harbour': ['hb'], 'Haskell': ['hs', 'lhs'], 'Haxe': ['hx'], 'HCL': ['hcl', 'nomad', 'tf'], 'HLSL': ['cg', 'cginc', 'hlsl', 'shader'], 'Hoon': ['hoon'], 'HTML': ['htm', 'html'], 'IDL': ['idl', 'pro'], 'Idris': ['idr'], 'Igor Pro': ['ipf'], 'INI': ['ini'], 'InstallShield': ['ism'], 'JavaServer Faces': ['jsf'], 'JCL': ['jcl'], 'JSON': ['json'], 'JSON5': ['json5'], 'JSP': ['jsp', 'jspf'], 'JSX': ['jsx'], 'Julia': ['jl'], 'Jupyter Notebook': ['ipynb'], 'Kermit': ['ksc'], 'Korn Shell': ['ksh'], 'Kotlin': ['kt', 'kts'], 'Lean': ['lean'], 'LESS': ['less'], 'lex': ['l'], 'LFE': ['lfe'], 'liquid': ['liquid'], 'Lisp': ['asd', 'el', 'lisp', 'lsp', 'cl', 'jl'], 'Literate Idris': ['lidr'], 'LiveLink OScript': ['oscript'], 'Logtalk': ['lgt', 'logtalk'], 'Lua': ['lua'], 'm4': ['ac', 'm4'], 'make': ['am', 'Gnumakefile', 'gnumakefile', 'makefile', 'Makefile', 'mk'], 'Mako': ['mako'], 'Markdown': ['md'], 'Mathematica': ['mt', 'wl', 'wlt', 'm'], 'MATLAB': ['m'], 'Maven': ['pom', 'pom.xml'], 'Modula3': ['i3', 'ig', 'm3', 'mg'], 'MSBuild script': ['csproj', 'vbproj', 'vcproj', 'wdproj', 'wixproj'], 'MUMPS': ['mps', 'm'], 'Mustache': ['mustache'], 'MXML': ['mxml'], 'NAnt script': ['build'], 'NASTRAN DMAP': ['dmap'], 'Nemerle': ['n'], 'Nim': ['nim'], 'Nix': ['nix'], 'Objective C': ['m'], 'Objective C++': ['mm'], 'OCaml': ['ml', 'mli', 'mll', 'mly'], 'OpenCL': ['cl'], 'Oracle Forms': ['fmt'], 'Oracle PL/SQL': ['bod', 'fnc', 'prc', 'spc', 'trg'], 'Oracle Reports': ['rex'], 'Pascal': ['dpr', 'p', 'pas'], 'Pascal/Puppet': ['pp'], 'Patran Command Language': ['pcl', 'ses'], 'Perl': ['perl', 'plh', 'plx', 'pm', 'pm6', 'pl'], 'PHP': ['php', 'php3', 'php4', 'php5', 'phtml'], 'PHP/Pascal': ['inc'], 'Pig Latin': ['pig'], 'PL/I': ['pl1'], 'PL/M': ['lit', 'plm'], 'PO File': ['po'], 'PowerBuilder': ['sra', 'srf', 'srm', 'srs', 'sru', 'srw'], 'PowerShell': ['ps1', 'psd1', 'psm1'], 'ProGuard': ['pro'], 'Prolog': ['P', 'pl', 'pro'], 'Protocol Buffers': ['proto'], 'Pug': ['pug'], 'PureScript': ['purs'],  'QML': ['qml'], 'Qt': ['ui'], 'Qt Linguist': ['ts'], 'Qt Project': ['pro'], 'Racket': ['rkt', 'rktl', 'scrbl'], 'RAML': ['raml'], 'RapydScript': ['pyj'], 'Razor': ['cshtml'], 'ReasonML': ['re', 'rei'], 'reStructuredText': ['rst'], 'Rexx': ['rexx'], 'Rmd': ['Rmd'], 'RobotFramework': ['robot', 'tsv'], 'Ruby': ['rake', 'rb'], 'Ruby HTML': ['rhtml'], 'Scheme': ['sc', 'sch', 'scm', 'sld', 'sls', 'ss'], 'sed': ['sed'], 'SKILL': ['il'], 'SKILL++': ['ils'], 'Slice': ['ice'], 'Slim': ['slim'], 'Smalltalk': ['st', 'cs'], 'Smarty': ['smarty', 'tpl'], 'Softbridge Basic': ['sbl', 'SBL'], 'Solidity': ['sol'], 'SparForte': ['sp'], 'Specman e': ['e'], 'SQL': ['psql', 'SQL', 'sql'], 'SQL Data': ['data.sql'], 'SQL Stored Procedure': ['spc.sql', 'spoc.sql', 'sproc.sql', 'udf.sql'], 'Standard ML': ['fun', 'sig', 'sml'], 'Starlark': ['bzl'], 'Stata': ['do', 'DO'], 'Stylus': ['styl'], 'SVG': ['SVG', 'svg'], 'Swift': ['swift'], 'SWIG': ['i'], 'Tcl/Tk': ['itk', 'tcl', 'tk'], 'Teamcenter met': ['met'], 'Teamcenter mth': ['mth'], 'TeX': ['bst', 'dtx', 'sty', 'tex', 'cls'], 'TITAN Project File Information': ['tpd'], 'Titanium Style Sheet': ['tss'], 'TOML': ['toml'], 'TTCN': ['ttcn', 'ttcn2', 'ttcn3', 'ttcnpp'], 'Twig': ['twig'], 'TypeScript': ['tsx', 'ts'], 'Unity-Prefab': ['mat', 'prefab'], 'Vala': ['vala'], 'Vala Header': ['vapi'], 'Velocity Template Language': ['vm'], 'VHDL': ['vhd', 'VHD', 'vhdl', 'VHDL'], 'vim script': ['vim'], 'Visual Basic': ['bas', 'ctl', 'dsr', 'frm', 'VB', 'vb', 'VBA', 'vba', 'vbs', 'VBS', 'cls'], 'Visual Fox Pro': ['SCA', 'sca'], 'Visualforce Component': ['component'], 'Visualforce Page': ['page'], 'Vuejs Component': ['vue'], 'WebAssembly': ['wast', 'wat'], 'Windows Message File': ['mc'], 'Windows Module Definition': ['def'], 'Windows Resource File': ['rc', 'rc2'], 'WiX include': ['wxi'], 'WiX source': ['wxs'], 'WiX string localization': ['wxl'], 'XAML': ['xaml'], 'xBase': ['prg'], 'xBase Header': ['ch'], 'XHTML': ['xhtml'], 'XMI': ['XMI', 'xmi'], 'XML': ['XML', 'xml'], 'XQuery': ['xq', 'xquery'], 'XSD': ['XSD', 'xsd'], 'XSLT': ['xsl', 'XSL', 'xslt', 'XSLT'], 'Xtend': ['xtend'], 'yacc': ['y'], 'YAML': ['yaml', 'yml'], 'zsh': ['zsh']};

  handleFormat = (value) =>{
    this.setState({ file_format: value });
  }

  submitPreCheck = () => {
    const { needManualScreen, suffix_screen } = this.state;

    if (cookie.load("isLogin") !== "true") {
      alert("请点击右上角的“用户登录”按钮进行登录！");
      return false;
    }

    if (needManualScreen && !suffix_screen) {
      alert("您已经开启手动筛选代码语言，请先筛选代码语言！");
      return false;
    }

    return true;
  };

  doCreateBatch = () => {
    // const { file, batchTitle, suffix_screen, file_format, needManualScreen } = this.state;
    const { file, jobTitle, suffix_screen, file_format, needManualScreen } = this.state;

    createBatch(cookie.load("ACCESS_TOKEN"), file, file_format, jobTitle, "DESCRIPTION", "code", needManualScreen?suffix_screen:"")
      .then((response) => {
        try{
          if(response.data.data.message === "logout") {
            ssoRefresh();
          }
        }
        catch(e){
          console.log(e);
        }
        const batchID = response.data.data.batch_id;
        this.setState({ submited: false });
        this.props.history.push("/result", { batchID });
      })
      .catch((err) => {
        console.log(err);
        alert(err);
        this.setState({ submited: false });
      });
  };

  doCreateJoint = () => {
    // const { file, batchTitle, jobTitle, file_format, suffix_screen, needManualScreen, lib_tag, lib_tag_p, needCheck, private_lib, with_self  } = this.state;
    const { file, jobTitle, file_format, suffix_screen, needManualScreen, lib_tag, lib_tag_p, needCheck, private_lib, with_self  } = this.state;

    let search_range = "";
    getBatchIdByLibTag(private_lib? cookie.load("ACCESS_TOKEN"):"", private_lib?lib_tag_p:lib_tag)
        .then((response) => {
          try{
            if(response.data.data.message === "logout") {
              ssoRefresh();
            }
          }
          catch(e){
            console.log(e);
          }

          search_range = response.data.data.result;

          craeteJointJob(cookie.load("ACCESS_TOKEN"), file, file_format, jobTitle, "", jobTitle, needCheck?search_range:"", "code", needManualScreen?suffix_screen:"", with_self)
              .then((response) => {
                try{
                  if(response.data.data.message === "logout") {
                    ssoRefresh();
                  }
                }
                catch(e){
                  console.log(e);
                }
                const batchID = response.data.data.batch_id;
                const jobID = response.data.data.job_id;
                this.setState({ submited: false });
                this.props.history.push("/result", { batchID, jobID });
              })
              .catch((err) => {
                console.log(err);
                alert(err);
                this.setState({ submited: false });
              });
        })
        .catch((err) => {
      console.log(err);
      alert(err);
      this.setState({ submited: false });
    });
  };

  handleUpdateFile = (file) => {
    this.setState({ file });
  };

  handleUpdateSuffix = (suffix_screen) => {
    this.setState({ suffix_screen });
  };
  handleUpdateLibTag = (lib_tag) => {
    this.setState({ lib_tag });
  };

  handleUpdateLibTagPrivate = (lib_tag_p) => {
    this.setState({ lib_tag_p });
  };

  handleSubmit = (isJoint) => {
    return () => {
      if (!this.submitPreCheck()) {
        return false;
      }
      if (this.state.needCheck && !(this.state.private_lib?this.state.lib_tag_p:this.state.lib_tag)) {
        alert("您已打开库查重，请添加对应的库标签！");
        return false;
      }

      this.setState({ submited: true });

      this.form.validate((valid) => {
        if (valid) {
          // const {with_self,CheckType, file, batchTitle, jobTitle } = this.state;
          const {with_self,CheckType, file, jobTitle } = this.state;

          if (!file.uid) {
            this.setState({ submited: false, showWarrning: true });
            return false;
          }
          if (with_self===false && CheckType===1) {
            alert("无意义的查重任务！请添加对比的查重数据库或开启包内互查后再提交查重任务。");
            // alert("已关闭库查重和自我查重，不允许提交！");
            this.setState({ submited: false});
            return false;
          }
          // if (!batchTitle) {
          //   alert("请填写代码包标题，或点击“自动生成标题”按钮！");
          //   this.setState({ submited: false });
          //   return false;
          // }

          if (isJoint) {
            if (!jobTitle) {
              alert("请填写查重任务标题，或点击“自动生成标题”按钮！");
              this.setState({ submited: false });
              return false;
            }
            this.doCreateJoint();
          } else {
            this.doCreateBatch();
          }
        } else {
          console.log("error submit!!");
          this.setState({ submited: false });
          return false;
        }
      });
    };
  };

  handleAutoTitle = (callbackFunc) => {
    const nowDate = dateFormater("yyyy-MM-dd_HH:mm:ss");

    if (typeof callbackFunc !== "function") {
      callbackFunc = () => {};
    }

    this.setState(
      {
        // batchTitle: `代码包_${nowDate}`,
        jobTitle: `代码任务_${nowDate}`,
      },
      callbackFunc
    );
  };

  onChange = (key, value) => {
    this.setState({ [key]: value });
  };

  onCheckChange = (key, value) => {
    if(value===1){
      this.setState({ needCheck: false });
      this.setState({ CheckType: 1 });
    }
    if(value===2){
      this.setState({ needCheck: true});
      this.setState({ private_lib: true});
      this.setState({ CheckType: 2 });
    }
    if(value===3){
      this.setState({ needCheck: true});
      this.setState({ private_lib: false});
      this.setState({ CheckType: 3 });
    }
  };

  onDismissWarning = () => {
    this.setState({ showWarrning: false });
  };

  render() {
    this.state.selectCodeOption = [];
    for(let lang in this.langList){
      this.state.selectCodeOption.push({
        value: lang,
        label: lang,
      })
    }

    const {
      file,
      needCheck,
      needManualScreen,
      selectCodeOption,
      submited,
      showWarrning,
      // batchTitle,
      jobTitle,
      showTips,
      private_lib,
      with_self,
      activeCollapse,
    } = this.state;

    return (
      <div className="px-2">

        <Dialog
            title="查看对应后缀"
            size="small"
            visible={showTips}
            onCancel={() => this.setState({ showTips: false })}
            lockScroll={false}
        >
          <Dialog.Body>
            <ul>
              <pre>
                <h6>
              ABAP                       (abap)                                                     <br/>
              ActionScript               (as)                                                       <br/>
              Ada                        (ada, adb, ads, pad)                                       <br/>
              ADSO/IDSM                  (adso)                                                     <br/>
              AMPLE                      (ample, dofile, startup)                                   <br/>
              Ant                        (build.xml)                                                <br/>
              Apex Trigger               (trigger)                                                  <br/>
              Arduino Sketch             (ino, pde)                                                 <br/>
              ASP                        (asa, asp)                                                 <br/>
              ASP.Net                    (asax, ascx, asmx, aspx, config, master, sitemap, webinfo) <br/>
              Assembly                   (asm, s, S)                                                <br/>
              AutoHotkey                 (ahk)                                                      <br/>
              awk                        (awk)                                                      <br/>
              Bourne Again Shell         (bash)                                                     <br/>
              Bourne Shell               (sh)                                                       <br/>
              C                          (c, ec, pgc)                                               <br/>
              C Shell                    (csh, tcsh)                                                <br/>
              C#                         (cs)                                                       <br/>
              C++                        (C, c++, cc, cpp, cxx, pcc)                                <br/>
              C/C++ Header               (h, H, hh, hpp)                                            <br/>
              CCS                        (ccs)                                                      <br/>
              Clojure                    (clj)                                                      <br/>
              ClojureScript              (cljs)                                                     <br/>
              CMake                      (cmake, CMakeLists.txt)                                    <br/>
              COBOL                      (cbl, CBL, cob, COB)                                       <br/>
              CoffeeScript               (coffee)                                                   <br/>
              ColdFusion                 (cfm)                                                      <br/>
              ColdFusion CFScript        (cfc)                                                      <br/>
              CSS                        (css)                                                      <br/>
              CUDA                       (cu)                                                       <br/>
              Cython                     (pyx)                                                      <br/>
              D/dtrace                   (d)                                                        <br/>
              DAL                        (da)                                                       <br/>
              Dart                       (dart)                                                     <br/>
              diff                       (diff)                                                     <br/>
              DITA                       (dita)                                                     <br/>
              DOS Batch                  (bat, BAT, btm, BTM, cmd, CMD)                             <br/>
              DTD                        (dtd)                                                      <br/>
              ECPP                       (ecpp)                                                     <br/>
              Elixir                     (ex, exs)                                                  <br/>
              ERB                        (ERB, erb)                                                 <br/>
              Erlang                     (erl, hrl)                                                 <br/>
              Expect                     (exp)                                                      <br/>
              F#                         (fs, fsi)                                                  <br/>
              Focus                      (focexec)                                                  <br/>
              Fortran 77                 (f, F, f77, F77, for, FOR, FTN, ftn, pfo)                  <br/>
              Fortran 90                 (f90, F90)                                                 <br/>
              Fortran 95                 (f95, F95)                                                 <br/>
              Go                         (go)                                                       <br/>
              Grails                     (gsp)                                                      <br/>
              Groovy                     (gant, gradle, groovy)                                     <br/>
              Haml                       (haml)                                                     <br/>
              Handlebars                 (handlebars, hbs)                                          <br/>
              Harbour                    (hb)                                                       <br/>
              Haskell                    (hs, lhs)                                                  <br/>
              HLSL                       (cg, cginc, shader)                                        <br/>
              HTML                       (htm, html)                                                <br/>
              IDL                        (idl)                                                      <br/>
              IDL/Qt Project/Prolog      (pro)                                                      <br/>
              InstallShield              (ism)                                                      <br/>
              Java                       (java)                                                     <br/>
              Javascript                 (js)                                                       <br/>
              JavaServer Faces           (jsf, xhtml)                                               <br/>
              JCL                        (jcl)                                                      <br/>
              JSON                       (json)                                                     <br/>
              JSP                        (jsp, jspf)                                                <br/>
              Kermit                     (ksc)                                                      <br/>
              Korn Shell                 (ksh)                                                      <br/>
              Kotlin                     (kt)                                                       <br/>
              LESS                       (less)                                                     <br/>
              lex                        (l)                                                        <br/>
              Lisp                       (el, lisp, lsp, sc)                                        <br/>
              Lisp/Julia                 (jl)                                                       <br/>
              Lisp/OpenCL                (cl)                                                       <br/>
              LiveLink OScript           (oscript)                                                  <br/>
              Lua                        (lua)                                                      <br/>
              m4                         (ac, m4)                                                   <br/>
              make                       (am, gnumakefile, Gnumakefile, makefile, Makefile)         <br/>
              MATLAB                     (m)                                                        <br/>
              Maven                      (pom, pom.xml)                                             <br/>
              Modula3                    (i3, ig, m3, mg)                                           <br/>
              MSBuild script             (csproj, vbproj, vcproj, wdproj, wixproj)                  <br/>
              MUMPS                      (mps, m)                                                   <br/>
              Mustache                   (mustache)                                                 <br/>
              MXML                       (mxml)                                                     <br/>
              NAnt script                (build)                                                    <br/>
              NASTRAN DMAP               (dmap)                                                     <br/>
              Objective C                (m)                                                        <br/>
              Objective C++              (mm)                                                       <br/>
              OCaml                      (ml, mli, mll, mly)                                        <br/>
              Oracle Forms               (fmt)                                                      <br/>
              Oracle Reports             (rex)                                                      <br/>
              Pascal                     (dpr, p, pas)                                              <br/>
              Pascal/Puppet              (pp)                                                       <br/>
              Patran Command Language    (pcl, ses)                                                 <br/>
              Perl                       (perl, plh, plx, pm)                                       <br/>
              Perl/Prolog                (PL, pl)                                                   <br/>
              PHP                        (php, php3, php4, php5)                                    <br/>
              PHP/Pascal                 (inc)                                                      <br/>
              Pig Latin                  (pig)                                                      <br/>
              PL/I                       (pl1)                                                      <br/>
              PowerShell                 (ps1)                                                      <br/>
              Prolog                     (P)                                                        <br/>
              Protocol Buffers           (proto)                                                    <br/>
              PureScript                 (purs)                                                     <br/>
              Python                     (py)                                                       <br/>
              QML                        (qml)                                                      <br/>
              R                          (R)                                                        <br/>
              Racket                     (rkt, rktl, sch, scm, scrbl, ss)                           <br/>
              Razor                      (cshtml)                                                   <br/>
              Rexx                       (rexx)                                                     <br/>
              RobotFramework             (robot, tsv)                                               <br/>
              Ruby                       (rake, rb)                                                 <br/>
              Ruby HTML                  (rhtml)                                                    <br/>
              Rust                       (rs)                                                       <br/>
              SAS                        (sas)                                                      <br/>
              SASS                       (sass, scss)                                               <br/>
              Scala                      (scala)                                                    <br/>
              sed                        (sed)                                                      <br/>
              SKILL                      (il)                                                       <br/>
              SKILL++                    (ils)                                                      <br/>
              Smarty                     (smarty, tpl)                                              <br/>
              Softbridge Basic           (sbl, SBL)                                                 <br/>
              SQL                        (psql, sql, SQL)                                           <br/>
              SQL Data                   (data.sql)                                                 <br/>
              SQL Stored Procedure       (spc.sql, spoc.sql, sproc.sql, udf.sql)                    <br/>
              Standard ML                (fun, sig, sml)                                            <br/>
              Swift                      (swift)                                                    <br/>
              Tcl/Tk                     (itk, tcl, tk)                                             <br/>
              Teamcenter met             (met)                                                      <br/>
              Teamcenter mth             (mth)                                                      <br/>
              Text                       (txt)                                                      <br/>
              Titanium Style Sheet       (tss)                                                      <br/>
              TypeScript                 (ts)                                                       <br/>
              Unity-Prefab               (mat, prefab)                                              <br/>
              Vala                       (vala)                                                     <br/>
              Vala Header                (vapi)                                                     <br/>
              Velocity Template Language (vm)                                                       <br/>
              Verilog-SystemVerilog      (sv, svh, v)                                               <br/>
              VHDL                       (VHD, vhd, vhdl, VHDL)                                     <br/>
              vim script                 (vim)                                                      <br/>
              Visual Basic               (bas, cls, ctl, dsr, frm, VB, vb, VBA, vba, vbs, VBS)      <br/>
              Visual Fox Pro             (sca, SCA)                                                 <br/>
              Visualforce Component      (component)                                                <br/>
              Visualforce Page           (page)                                                     <br/>
              Windows Message File       (mc)                                                       <br/>
              Windows Module Definition  (def)                                                      <br/>
              Windows Resource File      (rc, rc2)                                                  <br/>
              WiX include                (wxi)                                                      <br/>
              WiX source                 (wxs)                                                      <br/>
              WiX string localization    (wxl)                                                      <br/>
              XAML                       (xaml)                                                     <br/>
              xBase                      (prg)                                                      <br/>
              xBase Header               (ch)                                                       <br/>
              XML                        (XML, xml)                                                 <br/>
              XQuery                     (xq, xquery)                                               <br/>
              XSD                        (xsd, XSD)                                                 <br/>
              XSLT                       (xsl, XSL, xslt, XSLT)                                     <br/>
              yacc                       (y)                                                        <br/>
              YAML                       (yaml, yml)
                </h6>
                </pre>
            </ul>
          </Dialog.Body>
          <Dialog.Footer className="dialog-footer">
            <Button
                type="success"
                onClick={() => {
                  this.setState({ showTips: false });
                }}
            >
              确定
            </Button>
          </Dialog.Footer>
        </Dialog>

        <UncontrolledAlert
          color="warning"
          fade={false}
          toggle={this.onDismissWarning}
          style={{ display: showWarrning ? "block" : "none" }}
        >
          <span className="alert-inner--icon">
            <i className="ni ni-air-baloon" />
          </span>{" "}
          <span className="alert-inner--text">
            <strong>请注意！</strong>{" "}
            您尚未上传需要查重的代码包（点击“选择文件”按钮上传）！
          </span>
        </UncontrolledAlert>
        <Form ref={(c) => (this.form = c)} model={this.state}>
          <h4 className="text-primary font-weight-bold mb-4">
            上传待查代码包
          </h4>
          {/*<Form.Item prop="batchTitle">*/}
          {/*  <Input*/}
          {/*    value={this.state.batchTitle}*/}
          {/*    style={{ cursor: "default" }}*/}
          {/*    onChange={this.onChange.bind(this, "batchTitle")}*/}
          {/*    placeholder="请输入本次上传的代码包标题"*/}
          {/*    prepend={*/}
          {/*      <div style={{ width: "100px", color: "#172b4d" }}>*/}
          {/*        代码包标题*/}
          {/*      </div>*/}
          {/*    }*/}
          {/*    append={*/}
          {/*      <Button type="primary" onClick={this.handleAutoTitle}>*/}
          {/*        自动生成标题*/}
          {/*      </Button>*/}
          {/*    }*/}
          {/*  />*/}
          {/*</Form.Item>*/}
          <Form.Item prop="jobTitle">
            <Input
                value={this.state.jobTitle}
                style={{ cursor: "default" }}
                onChange={this.onChange.bind(this, "jobTitle")}
                placeholder="请输入本次查重任务名称"
                prepend={
                  <div style={{ width: "100px", color: "#172b4d" }}>
                    查重任务名
                  </div>
                }
                append={
                  <Button type="primary" onClick={this.handleAutoTitle}>
                    自动生成
                  </Button>
                }
            />
          </Form.Item>
          <Form.Item prop="batchUpload">
            <Upload handleUpdateFile={this.handleUpdateFile} handleFormat={this.handleFormat}/>
          </Form.Item>
          <Form.Item prop="needManualScreen">
            <Row>
              <Col lg="7">
                <Input
              readOnly
              style={{ cursor: "default" }}
              placeholder={
                needManualScreen ? "手动筛选代码语言已经打开" : "自动筛选高频代码语言（不建议）"
              }
              onChange={this.onChange.bind(this, "needManualScreen")}
              prepend={
                <div style={{ width: "150px", color: "#172b4d" }}>
                  开启手动筛选代码语言
                </div>
              }
              append={
                <div>
                  <Switch
                      className="mb-0"
                      style={{ display: "inline-block" }}
                      value={needManualScreen}
                      onChange={this.onChange.bind(this, "needManualScreen")}
                  />
                  <div
                      className="ml-3"
                      style={{display: "inline-block"}}
                  />
                </div>
              }
                />
              </Col>
              <Col lg="2">
                <Button
                    type="warning"
                    icon="information"
                    onClick={() => this.setState({ showTips: true })}
                    style={{ width: "100%" ,display: needManualScreen ? "block" : "none" }}
                >
                  查看对应后缀
                </Button>
              </Col>
            </Row>
          </Form.Item>
          <Form.Item style={{ display: needManualScreen ? "block" : "none" }}>
            <Row>
              <Col lg="12">
                <Select_pure
                    title="选择参与查重的代码语言"
                    placeholder="再次选择或点击标签可以删除已选"
                    options={selectCodeOption}
                    filterable={false}
                    handleUpdateSuffix={this.handleUpdateSuffix}
                />
              </Col>
            </Row>
          </Form.Item>

          {/*<h4 className="text-primary font-weight-bold mb-4">*/}
          {/*  第二步：提交查重任务*/}
          {/*</h4>*/}
          <Collapse accordion value={this.state.activeCollapse} onChange={(e) => this.state.activeCollapse = e} >
            <Collapse.Item title="高级配置项（与历史代码包进行查重对比）" name="1" >
              {/*<Form.Item prop="jobTitle">*/}
              {/*  <Input*/}
              {/*    value={this.state.jobTitle}*/}
              {/*    style={{ cursor: "default" }}*/}
              {/*    onChange={this.onChange.bind(this, "jobTitle")}*/}
              {/*    placeholder="请输入本次查重任务的标题"*/}
              {/*    prepend={*/}
              {/*      <div style={{ width: "100px", color: "#172b4d" }}>*/}
              {/*        查重任务标题*/}
              {/*      </div>*/}
              {/*    }*/}
              {/*    append={*/}
              {/*      <Button type="primary" onClick={this.handleAutoTitle}>*/}
              {/*        自动生成标题*/}
              {/*      </Button>*/}
              {/*    }*/}
              {/*  />*/}
              {/*</Form.Item>*/}

              <Form.Item>
                <br/>
                <Row>
                  <Col lg="3" >
                    <div>
                      加入对比的查重数据库:
                    </div>
                  </Col>
                  <Col lg="4" >
                    <Radio.Group onChange={this.onCheckChange.bind(this, "CheckType")} value={this.state.CheckType}>
                      <Radio.Button value={1} checked={this.state.CheckType === 1}>无</Radio.Button>
                      <Radio.Button value={2} checked={this.state.CheckType=== 2}>私有库</Radio.Button>
                      <Radio.Button value={3} checked={this.state.CheckType === 3}>公有库</Radio.Button>
                    </Radio.Group>
                  </Col>
                  <Col lg="5" >
                    <div>
                      说明：提交的代码将与所选库中的历史代码进行查重对比
                    </div>
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item>
                <Row>
                  <Col lg="3" >
                    <div>
                      包内文件是否需要互查:
                    </div>
                  </Col>
                  <Col lg="4" >
                    <Radio.Group onChange={this.onChange.bind(this, "with_self")} value={this.state.with_self}>
                      <Radio.Button value={false} checked={this.state.with_self === false}>否</Radio.Button>
                      <Radio.Button value={true} checked={this.state.with_self === true}>是</Radio.Button>
                    </Radio.Group>
                  </Col>
                  <Col lg="5" >
                    <div>
                      说明：若选择"是"，所提交压缩包内文件将会互相查重比对
                    </div>
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item style={{ display: needCheck ? (private_lib ? "none":"block") : "none" }}>
                <Row>
                  <Col lg="12">
                    <Search_lib
                      title="搜索库标签"
                      handleUpdateLibTag={this.handleUpdateLibTag}
                    />
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item style={{ display: needCheck ? (private_lib ? "block":"none") : "none" }}>
                <Row>
                  <Col lg="12">
                    <Search_lib_private
                        title="搜索库标签"
                        handleUpdateLibTag={this.handleUpdateLibTagPrivate}
                    />
                  </Col>
                </Row>
              </Form.Item>
            </Collapse.Item>
          </Collapse>

          <br/>

          <BootButton
            color="primary"
            size="lg"
            block
            onClick={this.handleSubmit(true)}
            disabled={
              file.uid
                  ? jobTitle
                      ? submited
                      : true
                  : true
            }
          >
            {file.uid
                ? jobTitle
                    ? submited
                        ? "查重任务已经提交"
                        : "代码包提交并启动查重任务"
                    : "尚未填写查重任务名"
                : "尚未添加待查重代码包"}
          </BootButton>
        </Form>
      </div>
    );
  }
}

export default withRouter(CreateJobForm);
